import { Icon } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledIcon = styled(Icon)`
  display: flex;
  align-items: center;
`;
